import { withUserContext, withUIContext } from 'context'
import { ButtonSimple, Text, Popup } from 'components/common'

const DeactivateProfilePopup = ({ deactivateAccount, toggleDeactivatePopup, deactivatePopupIsOpen, enableDomScroll, ...props }) => {
	return (
		<Popup
			functionClose={() => {
				toggleDeactivatePopup();
				enableDomScroll()
			}}
			className={`${props.className}`}
			popupIsOpen={deactivatePopupIsOpen}>
			<div className='deactivate-popup flexBoxColumn'>
				<Text tag='p' className='PopSemi h11' text='Deactivate profile' />
				<Text tag='p' className='sub PopSemi h9' text='Are you sure you want to deactivate your account?' />
				<Text tag='p' className='text PopReg const14'
					text="Deactivating your account will disable your Profile and remove your name and photo from most things that you've shared on Oplos. Some information may still be visible to others, such as your name and comments that you've sent." />
				<div className='buttons flexBox justifyEnd'>
					<ButtonSimple onClick={() => {
						toggleDeactivatePopup();
						enableDomScroll()
					}} className='white' text='Cancel' />
					<ButtonSimple onClick={deactivateAccount} className='red' text='Deactivate profile' />
				</div>
			</div>
		</Popup>
	)
}

export default withUIContext(withUserContext(DeactivateProfilePopup, ['deactivateAccount']), ['toggleDeactivatePopup', 'deactivatePopupIsOpen', 'enableDomScroll'])
